import React from "react";
import './header.css';
import userImage from '../../assets/images/userImage.jpg';
import { IonIcon } from '@ionic/react';
import { menuOutline, searchOutline, notificationsOutline, mailOutline } from 'ionicons/icons';

class Header extends React.Component {
    render() {
        return (
            <div>
                <div className="topbar">
                    <div className="toggle">
                        <IonIcon icon={menuOutline} style={{ color: "#0A2352" }} />
                    </div>

                    <div className="search">
                        <label>
                            <input type="text" placeholder="Search here" />
                            <IonIcon icon={searchOutline} />
                        </label>
                    </div>

                    <div className="iconbox"></div>

                    <div className="toggle">
                        <IonIcon icon={notificationsOutline} style={{ color: "#ffffff" }} />
                    </div>
                    <div className="toggle">
                        <IonIcon icon={mailOutline} style={{ color: "#ffffff" }} />
                    </div>
                    <div className="user">
                        <img src={userImage} alt="User" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;
